export default __webpack_public_path__ + "static/media/inactive_users.800d9e87.svg";